import React from "react";
import PropTypes from "prop-types";
import DashboardComparisonBadge from "./DashboardComparisonBadge";
import DashboardPanel from "./DashboardPanel";

const DashboardProgressPanel = ({
    title,
    icon,
    percent,
    percentLabel,
    centerLabel,
    stats,
    comparisonFormatter
}) => {
    const radius = 34;
    const circumference = 2 * Math.PI * radius;
    const normalizedPercent = Math.min(Math.max(Number(percent || 0), 0), 100);
    const dash = (normalizedPercent * circumference) / 100;

    return (
        <DashboardPanel title={title} icon={icon}>
            <div className="dashboard-progress-wrap">
                <div className="dashboard-progress-ring">
                    <svg viewBox="0 0 84 84">
                        <circle cx="42" cy="42" r={radius} fill="none" stroke="var(--dashboard-accent-soft, #e4efe8)" strokeWidth="8" />
                        <circle
                            cx="42"
                            cy="42"
                            r={radius}
                            fill="none"
                            stroke="var(--99ca45, #05cc02)"
                            strokeWidth="8"
                            strokeDasharray={`${dash} ${circumference - dash}`}
                            strokeDashoffset="53"
                            strokeLinecap="round"
                        />
                    </svg>
                    <div className="dashboard-progress-label">
                        <div className="dashboard-progress-percent">{percentLabel}</div>
                        <div className="dashboard-progress-text">{centerLabel}</div>
                    </div>
                </div>
                <div className="dashboard-progress-stats">
                    {stats.map((stat) => (
                        <div className="dashboard-progress-row" key={stat.label}>
                            <span>{stat.label}</span>
                            {stat.comparison ? (
                                <DashboardComparisonBadge comparison={stat.comparison} formatComparison={comparisonFormatter} />
                            ) : (
                                <strong className={stat.danger ? "dashboard-danger-text" : ""}>{stat.value}</strong>
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </DashboardPanel>
    );
};

DashboardProgressPanel.propTypes = {
    title: PropTypes.string.isRequired,
    icon: PropTypes.node,
    percent: PropTypes.number.isRequired,
    percentLabel: PropTypes.string.isRequired,
    centerLabel: PropTypes.string.isRequired,
    stats: PropTypes.arrayOf(PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.string,
        danger: PropTypes.bool,
        comparison: PropTypes.object
    })).isRequired,
    comparisonFormatter: PropTypes.func.isRequired
};

DashboardProgressPanel.defaultProps = {
    icon: null
};

export default DashboardProgressPanel;
